import React, { useState } from 'react';
import DataTable from 'components/DataTable';
import { showError } from 'utils';
import styles from '../refund-report/index.module.scss';
import ActionButton from 'components/ActionButton';
import ExportCSVButton from 'components/ExportCSVButton';
import { fetchItemReplenishmentReport } from 'services';
import SupplierAutosuggest from 'components/SupplierAutosuggest';
import _ from 'lodash';
import { Loading } from 'components/loading/Loading';
import WeeklyData from './WeeklyData';
import Currency from 'components/Currency/Currency';

const groupTableColumns = [
  {
    name: 'Week',
    selector: 'week',
    sortable: true,
  },
  {
    name: 'Week Range',
    selector: 'weekRange',
    width: '250px',
  },
  {
    name: 'Total Unique items',
    selector: 'totalRows',
  },
  {
    name: 'Total items',
    selector: 'totalQuantity',
  },
  {
    name: 'Total Price',
    selector: 'totalPrice',
    // eslint-disable-next-line react/display-name
    cell: (row)=> <Currency amount={row.totalPrice}/>,
  },
  {
    name: '',
    selector: '',
  },
];

const columnsForCSV = [
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Week Range',
    value: 'weekRange',
  },
  {
    label: 'Item Name',
    value: 'inventoryItem.name',
  },
  {
    label: 'Item Id',
    value: 'inventoryItem.objectId',
  },
  {
    label: 'Stock',
    value: 'inventoryItem.stock',
  },
  {
    label: 'Unit',
    value: 'inventoryItem.unit.description',
  },
  {
    label: 'Category',
    value: 'inventoryItem.category.description',
  },
];

const ItemReplenishmentReport = props => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [groupData, setGroupData] = useState<Record<string, any>[]>([]);
  const [supplierId, setSupplierId] = useState<string>('');
  const [supplier, setSupplier] = useState<Record<string, any>>({});  
  const [loading, setLoading] = useState<boolean>(false);

  const fetchReportData = async () => {
    setLoading(true);
    try {
      const response = await fetchItemReplenishmentReport(supplierId);
      setGroupData(response.groupData);
      setData(response.rawData);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      {loading && <Loading/>}
      <div className={styles['header']}>
        <div className={styles['heading']}>Item ReplenishmentReport Report</div>
        <ExportCSVButton
          fileName={'Item_ReplenishmentReport_Report'}
          data={data}
          columnsForCSV={columnsForCSV}
        />
      </div>
      <div className={styles['filter-container']}>
        <div className={styles['autosuggest-group']}>
          <div className={styles['label']}>Supplier ID</div>
          <SupplierAutosuggest
            supplierName={supplier.full_name || ''}
            // eslint-disable-next-line @typescript-eslint/camelcase
            setSupplierName={val => setSupplier({ ...supplier, full_name: val })}
            setSupplier={setSupplier}
            setSupplierId={setSupplierId}
          />
        </div>
        <ActionButton
          text={'Submit'}
          active={!loading}
          isLoading={false}
          onClick={fetchReportData}
          customClass={'ml-4 my-auto'}
        />
      </div>
      <DataTable
        noHeader
        data={groupData}
        columns={groupTableColumns}
        expandableRows={true}
        expandableRowsComponent={<WeeklyData/>}
      />
    </div>
  );
};

export default ItemReplenishmentReport;